import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"

// Connects to data-controller="auto-aktualisierung"
export default class extends Controller {
	static targets = ["zeitpunkt"]
	static values = {
		anzeigeformat: "monat",
		link: String,
	}

	connect() {
		this.observer = new MutationObserver((mutationsList) => {
			for (let mutation of mutationsList) {
				// Überprüfe, ob das abgeschlossene Planungssignal hinzugefügt oder ersetzt wurde
				if (mutation.type === "childList") {
					mutation.addedNodes.forEach((node) => {
						if (this.planungBerechnetSignal(node)) {
							// Detailansicht aktualisieren
							this.aktualisieren()
						}
					})
				}
			}
		})

		this.observer.observe(document.body, { childList: true, subtree: true })
	}

	disconnect() {
		// Observer stoppen
		if (this.observer) {
			this.observer.disconnect()
			this.observer = null
		}
	}

	// private

	planungBerechnetSignal(node) {
		return node.dataset?.berechnungZiel === "planung" && node.dataset?.berechnungStatus === "abgeschlossen"
	}

	aktualisieren() {
		const query = { anzeigeformat: this.anzeigeformatValue, zeitpunkt: this.zeitpunktTarget.innerHTML }

		const response = patch(this.linkValue, { responseKind: "turbo-stream", query: query })
		if (response.ok) {
		}
	}
}
